/*
 * @Author: Json Chen
 * @Date: 2021-09-27 18:49:00
 * @LastEditTime: 2022-06-16 11:16:04
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/GiftPurchase/GiftPurchaseEdit/UsageLimitation/index.tsx
 */
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
// import css from './css.module.less';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import UsageLimitationComp, {
  EField,
} from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/UsageLimitation';
import { _type } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/GiftPurchase/GiftPurchaseEdit/CustomerEligibleCondition';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';

export const maxPerCustomerCheckbox = [
  'userLimitation',
  'maxPerCustomerEnabled',
];

//const usedAmount = ['userLimitation', 'usedCount'];
const UsageLimitation = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const fields = [
    {
      field: EField.maxInTotal,
      checkboxName: ['userLimitation', 'maxInTotalEnabled'],
      valueName: ['userLimitation', 'maxInTotal'],
      description: getI18n('salesChannelDirectDiscount.usage.setMaxNumber'),
    },
    {
      field: EField.maxPerCustomer,
      checkboxName: maxPerCustomerCheckbox,
      valueName: ['userLimitation', 'maxPerCustomer'],
      disabledDependency: _type,
      description: getI18n(
        'salesChannelDirectDiscount.usage.setMaxNumberForCustomer',
      ),
    },
  ];
  const { used, disableEdit } = props;

  return (
    <SectionWrapper
      className={css.sectionContainer}
      title={getI18n('salesChannelDirectDiscount.limitation.usageLimitation')}>
      <UsageLimitationComp
        fields={fields}
        used={used}
        disableEdit={disableEdit}
        // usedAmountName={usedAmount}
      />
    </SectionWrapper>
  );
};

export default UsageLimitation;
